import { render, staticRenderFns } from "./SelectTagsField.vue?vue&type=template&id=3b5f3578&scoped=true&"
import script from "./SelectTagsField.vue?vue&type=script&lang=js&"
export * from "./SelectTagsField.vue?vue&type=script&lang=js&"
import style0 from "./SelectTagsField.vue?vue&type=style&index=0&id=3b5f3578&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f3578",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
